import useSWR from 'swr'
import { LeadService } from '@forwardflow/services/LeadService'

export const useContactDetails = (leadId: number | null) => {
   return useSWR(
      leadId ? `/leads/${leadId}` : null,
      async () => {
         if (!leadId) return null
         const response = await LeadService.getLeadById(leadId)
         if (!response) {
            throw new Error('Lead not found')
         }
         return response
      },
      {
         revalidateOnFocus: false,
         shouldRetryOnError: false,
      }
   )
}
